export const isFlagEligible = (flagValue) => !['OFF', 'A'].includes(flagValue)

export const customFlagValue = ({ flagName, defaultValue }) => {
  switch (flagName) {
    case 'voucherCheckout':
      return 'B'
    case 'shoppingBagRedesign':
      return 'B' // LOCAL-ONLY: temporarily on so the new-design cart row is
    // actually reachable while building it. Revert before committing.
    default:
      return defaultValue
  }
}
